import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { Observable } from 'rxjs';
import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import { Service } from './ctl-vgas-birim-dosya-belge-arama.service';
import { VgasBirimDosyaBelgeService } from '../ctl-vgas-birim-dosya-belge.service';
import {DlistDto} from "@dabnet-kamu/libs/ui";

@Component({
  selector: 'dk-ctl-vgas-birim-dosya-belge-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
  templateUrl: './ctl-vgas-birim-dosya-belge-arama.component.html',
  styleUrls: ['./ctl-vgas-birim-dosya-belge-arama.component.scss'],
})
export class CtlVgasBirimDosyaBelgeAramaComponent implements OnInit  {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<any>();
  constructor(
    private service: Service,
    private vgasBirimDosyaBelgeService:VgasBirimDosyaBelgeService,
    public ortakService:OrtakService

  ) {
  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.vgasBirimDosyaBelgeService.gridControlsList$;
    this.vgasBirimDosyaBelgeService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }


  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}


